<template>
    <div>
        <TheHeader />
        <router-view></router-view>
    </div>
</template>

<script>
import TheHeader from './TheHeader';
export default {
    components: {
        TheHeader,
    },
};
</script>
